import axios from "axios";
import { AppConfig } from "../../shared/utilities/AppConfig";
import { SearchOrganizationProfilesResponse } from "../../shared/definitions/internationalTypes";

export type SearchOrganizationProfilesParams = {
  search: string;
  page?: number;
};

export default async function searchOrganizationProfiles(
  params: SearchOrganizationProfilesParams,
) {
  const { search, ...restParams } = params;
  const { data } = await axios.get<SearchOrganizationProfilesResponse>(
    `${AppConfig.API_URL}/search_organisasi_internasional/${encodeURIComponent(search)}`,
    { params: restParams },
  );

  return data;
}
